import * as cookies from '../lib/cookies'

addEventListener('DOMContentLoaded', () => {
	const cookieBar = document.getElementById('ckbar')
	if (!cookieBar) {
		return
	}

	cookieBar.querySelector('#ckies-accept')?.addEventListener('click', (event) => {
		event.preventDefault()
		cookies.set('c_enabled', 'true')
		location.reload()
	})
	
	cookieBar.querySelector('#ckies-denied')?.addEventListener('click', (event) => {
		event.preventDefault()
		cookies.set('c_enabled', 'false')
		cookieBar.remove()
	})
})